








import { Component, Vue } from 'vue-property-decorator';
import ChecktestHeader from '@/components/checktest/ChecktestHeader.vue';
import Footer from '@/components/common/Footer.vue';
import ChecktestCompleteBox from '@/components/checktest/ChecktestCompleteBox.vue';

@Component({
  components: {
    ChecktestHeader,
    ChecktestCompleteBox,
    Footer,
  },
})
export default class ChecktestComplete extends Vue {
  // TODO テーブル参照と遷移先指定
}
